<template>
  <el-container>
    <el-header>
      <Header title="鹿客竞练管理后台"></Header>
    </el-header>
    <el-main class="activity-container">
      <div class="activity-header">
        <h2>
          <span style="cursor:pointer;">
            <router-link :to="{name: 'training'}">训练</router-link>
          </span>
          <i class="el-icon-arrow-right"></i>
          <span @click="toTrainIndex">{{title}}</span>
          <template v-if="title">
            <i class="el-icon-arrow-right"></i>
            {{task_title}}
          </template>
        </h2>
      </div>
      <div class="activity-box">
        <div class="activity-box-header">
          你已通过<span>{{passNum}}</span>/{{totalSize}}
        </div>
        <div class="activity-list">
          <div class="activity-list-header">
            <span>活动名称</span>
            <span>状态</span>
          </div>
          <div class="activity-list-box">
            <template v-for="(item,index) in showTable">
              <div class="activity-list-item" v-if="user_role" @click="paperPreview(item.id)">
                <span>{{item.paper_title}}</span>
                <span>预览</span>
              </div>
              <div class="activity-list-item" v-else-if="!item.is_read&&!item.is_post" @click="startCompetition(item.id)">
                <span>{{item.paper_title}}</span>
                <span v-html="judgeItemStatus(item.status,item.is_read,item.is_pass)"></span>
              </div>
              <div class="activity-list-item" v-else-if="item.is_read||item.is_post" @click="viewResult(item.id)">
                <span>{{item.paper_title}}</span>
                <span v-html="judgeItemStatus(item.status,item.is_read,item.is_pass)"></span>
              </div>
            </template>
          </div>
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20,50,100,200]"
          :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize"></el-pagination>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import Header from "@/layouts/app/Header";
import {
  selectEventData
} from "@/api/show";
export default {
  components: {
    Header,
  },
  data() {
    return {
      items: [],
      competitionId: "", //训练id
      replay_type: 1,//是正常训练还是专题进入的训练,1为正常，2为专题进入
      title: '',//应用名称
      task_title: '',//任务名称
      taskId: '',//任务id
      pagesize: 20, //设置每页显示条目个数为10
      totalSize: "", //总个数
      currentPage: 1, //设置当前页默认为1
      passNum: 0,//通过活动数
      user_role: 0,//用户角色，0为考生，1为评委，2为创建者
    }
  },
  mounted() {
    sessionStorage.removeItem('paperInfo')
    this.competitionId = this.$route.params.competitionId;
    this.taskId = this.$route.params.taskId;
    sessionStorage.setItem('competitionId', this.competitionId)
    sessionStorage.setItem('taskId', this.taskId)
    this.initData()
  },
  methods: {
    initData: function () {
      let params = {
        competition_id: this.competitionId,
        task_id: this.taskId,
        replay_type: this.replay_type
      };
      selectEventData(params).then(response => {
        this.title = response.competition.title
        this.task_title = response.title
        this.items = response.data
        this.user_role = response.competition.user_role
        this.calcTotalItem(response.data)
      });
    },
    //计算总活动数以及通过数
    calcTotalItem: function (data) {
      if (data) {
        data.forEach(element => {
          if (element.is_pass) {
            this.passNum += 1
          }
        });
      }

    },
    handleSizeChange: function (val) {
      this.pagesize = val;
    },
    handleCurrentChange: function (page) {
      this.currentPage = page;
    },
    toTrainIndex: function () {
      this.$router.push({ name: 'train-index', params: { competitionId: this.competitionId } })
    },
    //判断考生当前活动的状态，status为活动状态，0为未进入，1未进入未开始，2未进入未保存，3未已提交,isRead为是否已批阅，isPass为是否通过
    judgeItemStatus: function (status, isRead, isPass) {
      let sta = '';
      let cls = '';
      if (status === 0 || status === 1 || status === 2) {
        sta = '未挑战';
      } else if (status === 3) {
        if (isRead === 1) {
          if (isPass == 1) {
            sta = '已通过'
            cls = 'color:#409eff;'
          } else {
            sta = '未通过'
            cls = 'color:red;'
          }
        } else {
          sta = '待批阅'
          cls = 'color:#409eff;'
        }
      }
      let html = '<span style="' + cls + '">' + sta + '</span>'
      return html
    },
    //开始答题
    startCompetition: function (id) {
      this.$router.push({
        name: 'train-exercise',
        params: {
          competitionId: this.competitionId,
          paperId: id,
          replay_type: this.replay_type,
          classroom_id: 0
        }
      })
    },
    //查看成绩
    viewResult: function (id) {
      this.$router.push({
        name: 'train-view-result',
        params: {
          competitionId: this.competitionId,
          paperId: id,
          replay_type: this.replay_type,
          classroomId: 0
        }
      })
    },
    //预览活动
    paperPreview: function (id) {
      this.$router.push({
        name: 'preview',
        params: {
          paperId: id,
          competitionId: this.competitionId,
        }
      })
    }
  },
  computed: {
    //showTable计算属性通过slice方法计算表格当前应显示的数据
    showTable() {
      if (!this.items) {
        return true
      }
      this.totalSize = this.items.length;
      return this.items.slice(
        (this.currentPage - 1) * this.pagesize,
        this.currentPage * this.pagesize
      );
    },
  }
}
</script>
<style scoped>
.activity-container {
  width: 1000px;
  margin: auto;
  display: block;
  box-sizing: border-box;
}
.activity-header {
  line-height: 60px;
  border-bottom: 1px solid #dce1e6;
}
.activity-header i {
  font-size: 20px;
  position: relative;
  top: 3px;
  margin: 0 5px;
}
.activity-header span {
  cursor: pointer;
}
.activity-box {
  width: 960px;
}
.activity-box-header {
  text-align: right;
  margin: 10px 0;
  padding-right: 10px;
  box-sizing: border-box;
}
.activity-box-header span {
  color: red;
}
.activity-list {
  margin: 10px 0;
  border: 1px solid #dce1e6;
  box-sizing: border-box;
}
.activity-list-header {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  background-color: #f2f2f2;
  padding: 0 20px;
}
.activity-list-header span {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.activity-list-header span:first-child {
  width: 768px;
  box-sizing: border-box;
}
.activity-list-header span:last-child {
  width: 140px;
  text-align: center;
}

.activity-list-item {
  padding: 0 20px;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.activity-list-item span:first-child {
  display: inline-block;
  width: 768px;
  box-sizing: border-box;
}
.activity-list-item span:last-child {
  display: inline-block;
  width: 140px;
  text-align: center;
}
.activity-list-item:hover {
  background-color: #dce1e6;
}
</style>